<!--
 * @Date: 2020-05-15 14:05:18
 * @LastEditors: 黄栋
 * @LastEditTime: 2020-05-29 16:53:54
 * @FilePath: /xy-pc/src/views/onlineclass/playCourse.vue
--> 
<template>
  <div>
    <div class="videoArea">
      <div class="container">
        <div style="padding:10px 0;">
          <el-breadcrumb
            slot="label"
            style="margin-top: 13px;"
            separator-class="el-icon-arrow-right"
          >
            <el-breadcrumb-item :to="{ path: '/myCourse' }">
              <span style="color:#FFF">我的课程</span>
            </el-breadcrumb-item>
            <el-breadcrumb-item>
              <span style="color:#f2f2f1">课程播放</span>
            </el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="videoBox" @contextmenu.prevent>
          <video id="myVideo" class="video-js" oncontextmenu="return false">
            <source :src="videoDetail.vedio_url" />
          </video>
          <div class="replayBox" v-if="showReplay">
            <button class="replayButton" plain @click="replayVideo">重新播放</button>
          </div>
        </div>
      </div>
    </div>
    <!-- 课程详情 -->
    <div class="container" style="margin-top:40px;padding-bottom:40px">
      <el-row :gutter="20">
        <el-col :span="17">
          <div class="courseDetail">
            <div class="courseHead">
              <span class="tabItem" :class="[activeTab=='1'?'active':'']" @click="activeTab=1">课程列表</span>
              <span class="tabItem" :class="[activeTab=='2'?'active':'']" @click="activeTab=2">我要提问</span>
            </div>
            <div class="courseContent">
              <div v-if="activeTab==1">
                <div v-for="(item,index) in courseProcess" :key="index">
                  <p style="padding:5px 0;margin-bottom:10px">{{item.title}}


                    <a v-if="item.test_link" :href="item.test_link" target="_blank" style="float:right">
                    <el-button type="primary" size="mini">开始测试</el-button>
                  </a>
                  </p>
                  <el-progress
                    :text-inside="true"
                    :stroke-width="20"
                    :percentage="item.process>=100?100:(item.process-0).toFixed(2)"
                  ></el-progress>
                  <div class="course_list clearfix" v-for="itemc in item.videos" :key="itemc.id">
                    <p class="course_head">{{itemc.title}}</p>
                    <span
                      class="course_study"
                      @click="toNext({path:'/playCourse',query:{id:courseId,playId:itemc.id,classId:classId}})"
                    >{{itemc.status==1?"完成":itemc.status==-1?'继续学习':'开始学习'}}</span>
                    <!-- <div class="course_time">12:12:00/40:45:00</div> -->
                  </div>

                  
                </div>
                
              </div>
              <div v-else>
                <div>
                  <div class="quesList" v-for="(item,index) in questions" :key="index">
                    <div class="itemBox">
                      <span class="timeSec">{{item.crated_at}}</span>
                      {{item.content}}
                    </div>
                    <div class="itemBox">
                      <span class="timeSec">{{item.answerd_at}}</span>
                      <div class="ritchHtml" v-html="item.answer"></div>
                    </div>
                  </div>
                  <div class="qactionBox">
                    <el-input v-model="queVal">
                      <el-button slot="append" @click="dataSubmit">提问</el-button>
                    </el-input>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="7">
          <el-card v-if="videoDetail.course.expert">
            <div style="text-align:center">
              <p>讲师介绍</p>
              <el-image
                style="width:120px;margin:10px 0"
                v-if="videoDetail.course&&videoDetail.course.expert&&videoDetail.course.expert.avatar"
                :src="videoDetail.course.expert.avatar"
              ></el-image>
              <p
                v-if="videoDetail.course&&videoDetail.course.expert&&videoDetail.course.expert.real_name"
              >{{videoDetail.course.expert.real_name}}</p>
              <p></p>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </div>
    <el-dialog
      center
      :visible.sync="showQrurl"
      width="30%"
      :close-on-click-modal="false"
      :show-close="false"
      :close-on-press-escape="false"
    >
      <div style="text-align:center">
        <p style="margin-bottom:20px">为了您能更好的学习，请用微信扫一扫扫描下方二维码，完成自拍并上传照片。</p>
        <el-image style="width:150px;height:150px" :src="qrUrl" />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Video from "video.js";
// import "video.js/dist//zh-CN.js";
import "video.js/dist/video-js.css";
var see_time_integer = 0;
var myPlayer;
export default {
  inject: ["reload"],
  data() {
    return {
      test_link: "",
      queVal: "", //提问内容
      courseProcess: [
        {
          id: "章节id",
          title: "章节标题",
          process: 60,
        },
      ],
      recordTimer: "",
      queryRes: "",
      questions: [],
      activeTab: 1,
      classId: "",
      see_time_integer: "", //观看时长秒
      playId: "",
      qrUrl: "",
      showQrurl: false,
      isClass: false,
      showReplay: false,
      videofinsh: false,
      courseId: "",
      last: 0,
      videoDetail: {
        id: "", //ID
        title: "", //标题
        vedio_url: "", //视频地址(为空说明视频过期)
        see_time_integer: "", //观看时长秒
        chapter: {
          id: "", //章节id
          title: "", //章节标题
        },
        course: {
          id: "", //ID
          title: "", //课程标题
          expert: {
            id: "", //专家id
            real_name: "", //专家姓名
            avatar: "", //头像
          },
          duty: {
            id: "", //岗位id
            name: "", //岗位名称
          },
        },
      },
    };
  },

  created() {
    if (this.$route.query && this.$route.query.id) {
      this.courseId = this.$route.query.id;
      if (this.$route.query.playId) {
        this.playId = this.$route.query.playId;
      }
      if (this.$route.query.classId) {
        this.classId = this.$route.query.classId;
      }
      this.getProcess();
      this.getQuesList();
    } else {
      console.log(1);
    }
    document.onkeydown = function () {
      if (window.event && window.event.keyCode == 123) {
        event.keyCode = 0;

        event.returnValue = false;
      }
    };
  },
  mounted() {
    var video = document.getElementById("myVideo");
    let that = this;
    video.addEventListener("loadedmetadata", function (e) {
      console.log("提示视频的元数据已加载");
      that.see_time_integer = that.videoDetail.see_time_integer - 0;
      video.currentTime = that.videoDetail.see_time_integer - 0;
      // 判断视频有没有播放完
      if (Math.abs(video.duration - video.currentTime) < 5) {
        that.showReplay = true;
        that.videofinsh = true;
      }
    });
    //  14、timeupdate：目前的播放位置已更改时，播放时间更新
    video.addEventListener("timeupdate", function (e) {
      var current = video.currentTime;
      if (
        current - that.see_time_integer > 2 ||
        that.see_time_integer - current > 2
      ) {
        video.currentTime = that.see_time_integer;
        console.log("----", current - that.see_time_integer);
      } else {
        that.see_time_integer = current;
      }
    });
    video.addEventListener("play", function (e) {
      console.log("提示该视频正在播放中");
      that.setRecord();
      console.log(e);
    });
    video.addEventListener("pause", function (e) {
      console.log("暂停播放");
      // that.recordSecond();
      clearInterval(that.recordTimer);
    });
    // 15、ended：播放结束
    video.addEventListener("ended", function (e) {
      console.log("视频播放完了");
      console.log(e);
      that.recordSecond();
      clearInterval(that.recordTimer);
      clearInterval(this.queryRes);
      that.showReplay = true;
      that.videofinsh = true;
    });
  },
  beforeDestroy() {
    this.recordSecond();
    clearInterval(this.recordTimer);
    clearInterval(this.queryRes);
  },
  methods: {
    /**重播 */
    replayVideo() {
      var video = document.getElementById("myVideo");
      this.videoDetail.see_time_integer;
      this.see_time_integer = 0;
      video.currentTime = 0;
      myPlayer.play();
      this.showReplay = false;
    },
    /**暂停 */
    pauseVideo() {
      myPlayer.pause();
    },

    /**获取课程信息 */
    getProcess() {
      this.$http({
        url: "api/v1/auth/courses/process/" + this.courseId,
        method: "get",
        params: {
          user_course_id: this.classId,
        },
      })
        .then((res) => {
          if (res.status == 200) {
            this.courseProcess = res.data.course_process.chapters;
            this.test_link = res.data.course_process.test_link;
            let playId = "";
            if (
              this.courseProcess[0].videos &&
              this.courseProcess[0].videos[0]
            ) {
              playId = this.courseProcess[0].videos[0].id;
            }

            if (this.playId) {
              playId = this.playId;
            } else {
              this.playId = playId;
            }
            this.getVideoDetail(playId);
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          console.log(err);
          this.$message.error("系统错误");
        });
    },
    toNext(url) {
      this.$router.replace(url);
      this.reload();
    },
    getVideoDetail(playId) {
      if (!playId) {
        return false;
      }
      this.$http({
        url: "api/v1/auth/videos/" + playId,
        method: "get",
        params: {
          user_course_id: this.classId,
        },
      }).then((res) => {
        if (res.status == 200) {
          this.videoDetail = res.data.video;
          this.see_time_integer = this.videoDetail.see_time_integer;
          this.$nextTick(() => {
            myPlayer = Video(myVideo, {
              //确定播放器是否具有用户可以与之交互的控件。没有控件，启动视频播放的唯一方法是使用autoplay属性或通过Player API。
              controls: true,
              //自动播放属性,muted:静音播放

              //建议浏览器是否应在<video>加载元素后立即开始下载视频数据。
              preload: "auto",
              //设置视频播放器的显示宽度（以像素为单位）
              width: "800px",
              //设置视频播放器的显示高度（以像素为单位）
              height: "400px",
              //  设置中文需要导入中文语言包
              language: "zh-CN",
              notSupportedMessage: "此视频暂时无法播放",
            });
          });
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    /**获取问题列表 */
    getQuesList() {
      this.$http({
        url: "/api/v1/auth/courses/questions/" + this.courseId,
        method: "get",
        params: { page: this.page, limit: this.limit },
      }).then((res) => {
        if (res.status == 200) {
          this.questions = res.data.questions;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    /**循环请求记录时间 */
    setRecord() {
      this.recordTimer = setInterval(() => {
        this.recordSecond();
      }, 30000);
    },
    /**记录时间 */
    recordSecond() {
      //如果完成就不用记录了
      if (this.videofinsh) {
        return false;
      }
      this.$http({
        url: "api/v1/auth/videos/record/" + this.playId,
        method: "POST",
        data: {
          see_time_integer: this.see_time_integer.toFixed(1),
          user_course_id: this.classId,
        },
      }).then((res) => {
        if (res.data && res.data.take_a_picture) {
          myPlayer.pause();
          this.exitFullscreen();
          this.getQrCode();
        }
      });
    },
    exitFullscreen() {
      var de = document;
      if (de.exitFullscreen) {
        de.exitFullscreen();
      } else if (de.mozCancelFullScreen) {
        de.mozCancelFullScreen();
      } else if (de.webkitCancelFullScreen) {
        de.webkitCancelFullScreen();
      }
    },
    // 获取二维码
    getQrCode() {
      this.$http({
        url: "api/v1/auth/videos/qrcode/" + this.playId,
        method: "POST",
        data: {
          user_course_id: this.classId,
        },
      }).then((res) => {
        if (res.status == 200) {
          this.qrUrl = res.data.url;
          this.showQrurl = true;
          // 查询拍照结果
          clearInterval(this.recordTimer);
          clearInterval(this.queryRes);
          this.interValQuery();
        }
      });
    },
    interValQuery() {
      if (this.queryRes) {
        clearInterval(this.recordTimer);
        clearInterval(this.queryRes);
      }
      this.queryRes = setInterval(() => {
        this.queryResult();
      }, 6000);
    },
    // 查询拍照结果
    queryResult() {
      myPlayer.pause();
      this.$http({
        url: "api/v1/user-video-photos/check",
        method: "get",
        params: {
          video_id: this.playId,
          user_course_id: this.classId,
          user_id: sessionStorage.userId,
        },
      }).then((res) => {
        if (res.status == 200) {
          if (res.data && res.data.picture) {
            clearInterval(this.queryRes);
            this.showQrurl = false;
            myPlayer.play();
          } else {
            // this.$message.error("")
          }
        }
      });

      //
      //
    },
    /**提问 */
    dataSubmit() {
      for (let index = 0; index < this.questions.length; index++) {
        if (this.questions[index].content == this.queVal) {
          this.$message.error("该问题已经提问过");
          return false;
        }
      }

      this.$http({
        url: "api/v1/auth/courses/questions/" + this.courseId,
        method: "POST",
        data: {
          content: this.queVal,
          sysInfo: {},
        },
      }).then((res) => {
        if (res.status == 200) {
          this.queVal = "";
          this.getQuesList();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
  },
};
</script>
 
<style lang="less">
.qactionBox {
  margin-top: 20px;
}
.itemBox {
  position: relative;
  padding-top: 15px;
  padding-bottom: 10px;
  img {
    max-width: 100% !important;
    height: auto !important;
  }
  .timeSec {
    position: absolute;
    right: 0;
    color: #666;
  }
}

video {
  &:focus {
    outline: none;
  }
}
.video-js .vjs-big-play-button {
  left: 50% !important;
  top: 50% !important;
  margin-left: -2em;
  margin-top: -1.3em;
}
.vjs-picture-in-picture-control {
  display: none !important;
}
</style>
<style lang="less" scoped>
.videoArea {
  background-color: #2b2b2b;
}
.videoBox {
  width: 100%;
  min-height: 500px;
  margin-top: 20px;
  padding-bottom: 30px;
  position: relative;
  .replayBox {
    position: absolute;
    left: 0;
    bottom: 0;
    right: 0;
    top: 0;
    .replayButton {
      position: absolute;
      left: 50% !important;
      top: 50% !important;
      margin-left: -3.5em;
      margin-top: -2em;
      font-size: 2em;
      line-height: 1.5em;
      height: 2em;
      width: 6em;
      display: block;
      padding: 0;
      cursor: pointer;
      opacity: 1;
      border: 0.06666em solid #fff;
      background-color: #2b333f;
      background-color: rgba(43, 51, 63, 0.7);
      border-radius: 0.3em;
      -webkit-transition: all 0.4s;
      transition: all 0.4s;
      color: #fff;
    }
  }
  .video-js {
    width: 100%;
    min-height: 600px;
    &:focus {
      outline: none;
    }
  }
}
.course_list {
  padding: 10px 0 20px 30px;
  display: block;
  .course_head {
    font-size: 14px;
    color: #333;
  }
  .course_study {
    float: right;
    cursor: pointer;
  }
}
.quesList {
  padding: 10px 0;
}
.courseDetail {
  margin-top: 10px;
  border: rgba(229, 229, 229, 1) solid 1px;
  .courseHead {
    height: 70px;
    border-bottom: rgba(229, 229, 229, 1) solid 1px;
    text-align: center;
    .tabItem {
      display: inline-block;
      margin: 0 80px;
      height: 70px;
      line-height: 70px;
      cursor: pointer;
      &.active {
        border-bottom: 4px solid #2a82e4;
        color: #2a82e4;
      }
    }
  }
  .courseContent {
    padding: 20px;
    min-height: 400px;
  }
}
</style>